export interface RejectedFile {
    name: string;
    reason: string;
}

export function validateUploadItem(
    item: DataTransferItem,
    allowFolders: boolean,
    allowZips: boolean,
    rejectedFiles: RejectedFile[],
    maxFileSize?: number,
    rejectedFileTypes: string[] = []
): boolean {
    // Validate folders and zip files
    if ('webkitGetAsEntry' in item || 'getAsEntry' in item) {
        const getAsEntryMethod = ('getAsEntry' in item 
            ? (item as any).getAsEntry 
            : (item as any).webkitGetAsEntry).bind(item);
        
        const entry = getAsEntryMethod();
        
        if (entry && entry.isDirectory && !allowFolders) {
            rejectedFiles.push({
                name: entry.name || 'Unknown folder',
                reason: 'Folders are not allowed'
            });
            return false;
        }

        if (!allowZips && (
            entry?.isFile && item.getAsFile()?.type === 'application/zip'
        )) {
            rejectedFiles.push({
                name: entry?.name || 'Unknown',
                reason: 'ZIP file uploads are not allowed'
            });
            return false;
        }

        // Additional validation for ZIP files when they are allowed
        if (allowZips && entry?.isFile) {
            const file = item.getAsFile();
            if (file?.name.toLowerCase().endsWith('.zip') && file.type !== 'application/x-zip-compressed') {
                rejectedFiles.push({
                    name: file.name,
                    reason: 'Invalid ZIP file format'
                });
                return false;
            }
        }
    }

    // File type and size validation
    const file = item.getAsFile();
    if (file) {
        // Check if the file type or extension is rejected
        if (rejectedFileTypes.length > 0) {
            const rejectedType = rejectedFileTypes.find(type => 
                file.name.toLowerCase().endsWith(type.toLowerCase()) || file.type === type
            );
            
            if (rejectedType) {
                rejectedFiles.push({
                    name: file.name,
                    reason: `File type '${rejectedType}' is not allowed`
                });
                return false;
            }
        }
        
        // Check if the file exceeds the maximum size
        if (maxFileSize && file.size > maxFileSize) {
            rejectedFiles.push({
                name: file.name,
                reason: `File exceeds maximum size of ${maxFileSize} bytes (actual size: ${file.size} bytes)`
            });
            return false;
        }
    }

    return true;
}
